var path = '/ui/requiredIndicator/uiRequiredIndicator.tpl.html';
var html = "<div class=\"requiredIndicator\" >\r\n    <i ng-if=\"showGreen\" class=\"glyphicon glyphicon-ok\"></i>\r\n    <span ng-if=\"!showGreen\" class=\"glyphicon glyphicon-asterisk\"></span>\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;